import { createFileRoute } from "@tanstack/react-router";
import { VidenPage, videnHead } from "@/pages/VidenPage";

export const Route = createFileRoute("/viden/")({
  head: () => videnHead("da"),
  component: () => <VidenPage locale="da" />,
});
